import script from "./BotRoomButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BotRoomButton.vue?vue&type=script&setup=true&lang=ts"

import "./BotRoomButton.vue?vue&type=style&index=0&id=9aa99052&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa99052"]])

export default __exports__